module.exports = __webpack_public_path__ + "static/media/peanut-butter-chip.1a93b43c.png";